var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.5V18.5C3.75 18.8978 3.90804 19.2794 4.18934 19.5607C4.47064 19.842 4.85218 20 5.25 20H20.25C20.4489 20 20.6397 19.921 20.7803 19.7803C20.921 19.6397 21 19.4489 21 19.25V8.75C21 8.55109 20.921 8.36032 20.7803 8.21967C20.6397 8.07902 20.4489 8 20.25 8H5.25C4.85218 8 4.47064 7.84196 4.18934 7.56066C3.90804 7.27936 3.75 6.89782 3.75 6.5ZM3.75 6.5C3.75 6.10218 3.90804 5.72064 4.18934 5.43934C4.47064 5.15804 4.85218 5 5.25 5H18",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 15.125C17.4963 15.125 18 14.6213 18 14C18 13.3787 17.4963 12.875 16.875 12.875C16.2537 12.875 15.75 13.3787 15.75 14C15.75 14.6213 16.2537 15.125 16.875 15.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.0d9ac2801475ed158e56d08dfacbd0b5.svg";
export { ForwardRef as ReactComponent };